import { render } from "./PackageComparison.vue?vue&type=template&id=0953df96&scoped=true"
import script from "./PackageComparison.vue?vue&type=script&lang=js"
export * from "./PackageComparison.vue?vue&type=script&lang=js"

import "./PackageComparison.vue?vue&type=style&index=0&id=0953df96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0953df96"]])

export default __exports__